import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const SOILBASEDCROPCODE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('dominantHeight', 'Entity.SoilBasedCropCode.DominantHeight')
    .decimal()
    .build(),
  FieldBuilder
    .number('mediumAnnualIncrement', 'Entity.SoilBasedCropCode.MediumAnnualIncrement')
    .decimal()
    .build(),
  FieldBuilder
    .text('soilType', 'Entity.SoilBasedCropCode.SoilType')
    .maxLength(70)
    .build(),
  FieldBuilder
    .number('treeCount', 'Entity.SoilBasedCropCode.TreeCount')
    .build(),
];

export const SOILBASEDCROPCODE_CONFIG = {
  entityName: 'SoilBasedCropCode',
  localizationKey: 'Planning::Entity.SoilBasedCropCode',
  fields: SOILBASEDCROPCODE_FIELDS,
  permission: 'Planning.SoilBasedCropCodes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Inventory + MENU_NAME_SUFFIX,
};
